import Vue from "vue";
import api from "@/app";

Vue.config.devtools = true;

declare global {
  interface Window {
    z: any;
  }
}

if (window.z === undefined) {
  window.z = {};
}

window.z.infCalcAPI = api;

if (process.env.NODE_ENV !== "production") {
  api.initialize(69, 19, { theme: "#3333CC", light: "#CCCCFF" });
}
